import React, { useState, useEffect } from 'react';
import {
  Button, Card, Form, Col,
} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Error, Success } from '../Alert/index';
import api from '../../services/api';

export function UserPainel () {
  const history = useHistory();
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [colleges, setColleges] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [components, setComponents] = useState([]);
  const [values, setValues] = useState({});

  useEffect(() => {
    api.get('/colleges')
      .then((res) => {
        setColleges(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }, [history]);
  useEffect(() => {
    api.get('/components')
      .then((res) => {
        setComponents(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }, [history]);

  function updateComponents () {
    api.get('/components')
      .then((res) => {
        setComponents(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }

  function handleChangeValues (event) {
    if (event.target.name === 'college') {
      setValues({ ...values, [event.target.name]: JSON.parse(event.target.value) });
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  }

  function changeComponents (e) {
    const perm = JSON.parse(e.target.value);
    const filter = permissions.filter((item) => item._id !== perm._id);
    setPermissions(filter);
    const comp = components;
    comp.push(perm);
    setComponents(comp);
  }

  function changePermissions (e) {
    const comp = JSON.parse(e.target.value);
    const filter = components.filter((item) => item._id !== comp._id);
    setComponents(filter);
    const perm = permissions;
    perm.push(comp);
    setPermissions(perm);
  }

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
    } else {
      const permissionsArray = [];
      permissions.forEach((elemente) => {
        permissionsArray.push(elemente._id);
      });

      api.post('/users', {
        name: values.name,
        email: values.email,
        password: values.password,
        permissions: permissionsArray,
        college: values.college._id,
      })
        .then(() => {
          updateComponents();
          setSuccess(true);
          setValues({
            name: '',
            email: '',
            password: '',
            college: '',
          });
          setPermissions([]);
          const element = document.getElementById('msgSuccess');
          element.innerHTML = 'Usuário cadastrado com sucesso';
          setTimeout(() => setSuccess(false), 3000);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
            setTimeout(() => {
              localStorage.removeItem('logged');
              localStorage.removeItem('realm');
              history.go('/login');
            }, 2000);
          } else {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = err.response.data.error;
            setTimeout(() => setError(false), 3000);
          }
        });
    }
  };

  return (
    <div className="content-register">
      {error ? <Error><p id="msgError" /></Error> : null}
      {success ? <Success><p id="msgSuccess" /></Success> : null}
      <Card style={{ width: '100%' }}>
        <Card.Header>
          <h5>Cadastro de usuário Painel</h5>
        </Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="validationFullName">
                <Form.Label>Nome completo</Form.Label>
                <Form.Control
                  required
                  name="name"
                  value={values.name}
                  onChange={handleChangeValues}
                  type="text"
                  placeholder="Nome completo"
                />
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com o nome do usuário.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationEmail">
                <Form.Label>E-mail</Form.Label>
                <Form.Control
                  required
                  name="email"
                  value={values.email}
                  onChange={handleChangeValues}
                  type="email"
                  placeholder="E-mail"
                />
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com o e-mail do usuário.
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="validationPassword1">
                <Form.Label>Senha</Form.Label>
                <Form.Control
                  required
                  name="password"
                  value={values.password}
                  onChange={handleChangeValues}
                  type="password"
                  placeholder="Senha"
                />
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com a senha do usuário.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationSelectt">
                <Form.Label>Instituição</Form.Label>
                <Form.Control
                  as="select"
                  name="college"
                  custom
                  required
                  onChange={handleChangeValues}
                >
                  <option value="" selected>Selecione</option>
                  {colleges.map((college) => (
                    <option
                      value={
                        JSON.stringify(college)
                      }
                      key={college._id}
                    >
                      {college.name}

                    </option>

                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com a instituição.
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="validationSelectt">
                <Form.Label>Todas as permissões</Form.Label>
                <Form.Control
                  as="select"
                  name="college"
                  custom
                  multiple
                  onChange={changePermissions}
                >
                  {components.map((component) => (
                    <option
                      value={
                        JSON.stringify(component)
                      }
                      key={component._id}
                    >
                      {component.name}

                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com a instituição.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationSelectt">
                <Form.Label>Permissões do usuário</Form.Label>
                <Form.Control
                  as="select"
                  name="college"
                  custom
                  multiple
                  onChange={changeComponents}
                >
                  {permissions.map((permission) => (
                    <option
                      value={
                        JSON.stringify(permission)
                      }
                      key={permission._id}
                    >
                      {permission.name}

                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com a instituição.
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>

            <Button type="submit" variant="success">Cadastrar</Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
